//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: () => ({
    usuario: null,
  }),
  methods: {
    async submit() {
      await this.$store.dispatch("auth/password_recovery", this.usuario)

      this.$q
        .dialog({
          persistent: true,
          message: `Enviamos un correo a ${this.usuario}, con un link para poder reestablecer tu contraseña.`,
        })
        .onOk(() => {
          this.$router.push({ name: "login" })
        })
    },
  },
}
